import styled from 'styled-components';
import { getFadeAnimation } from '@/styles/helpers';

export const OverlayBox = styled.div<{ $isOpen: boolean; $opacity?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: -80px;
  background-color: ${({ $opacity }) => `rgba(0, 0, 0, ${$opacity ?? 0.4})`};
  z-index: 10100;

  ${({ $isOpen }) => getFadeAnimation($isOpen)}
`;
